export default class CallEvent {
  constructor(payload = {}) {
    this.payload = payload
    this.event = new CustomEvent('')
  }

  withPayload(payload) {
    this.payload = payload
    return this
  }

  buildEvent(name) {
    this.event = new CustomEvent(name, { detail: this.payload })
    return this
  }

  publishEvent() {
    window.dispatchEvent(this.event)
  }
}
